// Layout.js
import React, { useState, useCallback, Suspense } from 'react';
import { Outlet } from 'react-router-dom'; 
import Navigation from '@/components/ui/navigation/top-nav/Navigation';
import LeftDrawer from '@/components/ui/navigation/drawer/LeftDrawer';
import RightDrawer from '@/components/ui/navigation/drawer/RightDrawer';
import useDocumentTitle from '@/hooks/useDocumentTitle'; 

const Layout = ({ pageTitle }) => {
  const [leftDrawerOpen, setLeftDrawerOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);

  useDocumentTitle(pageTitle);

  // Memoize the toggle functions
  const toggleLeftDrawer = useCallback(() => {
    setLeftDrawerOpen(prev => !prev);
  }, []);

  const toggleRightDrawer = useCallback(() => {
    setRightDrawerOpen(prev => !prev);
  }, []);

  const handleLogout = () => {
    const logoutForm = document.getElementById('logoutForm');
    if (logoutForm) {
      logoutForm.submit();
    }
  };

  return (
    <div>
      <Navigation
        toggleLeftDrawer={toggleLeftDrawer}
        toggleRightDrawer={toggleRightDrawer}
        pageTitle={pageTitle}
      />
      <LeftDrawer open={leftDrawerOpen} toggleDrawer={toggleLeftDrawer} />
      <RightDrawer open={rightDrawerOpen} toggleDrawer={toggleRightDrawer} logoutHandler={handleLogout} />
      <main>
        <Suspense fallback={<div>Loading content...</div>}>
          <Outlet /> {/* Lazily loaded child routes */}
        </Suspense>
      </main>
      <form id="logoutForm" method="POST" action="/accounts/logout/" style={{ display: 'none' }}>
        <input type="hidden" name="csrfmiddlewaretoken" value={document.cookie.match(/csrftoken=([^;]+)/)?.[1]} />
      </form>
    </div>
  );
};

export default Layout;
